import Status from './Status';
export type { StatusProps } from './Status.types';

export default Status;
